import { createAsyncThunk } from "@reduxjs/toolkit";
import { triggerAlert } from "redux/reducers/appSlice";
import { setAuthUser } from "redux/reducers/authSlice";
import ProfileService from "services/profile";
import { translateFrontEndAlerts } from "../../utils/translation";
import { getAuthUserProfile } from "redux/actions";

export const editProfile = createAsyncThunk(
  "edit/profile",
  async (data: FormData, { rejectWithValue, dispatch, getState }) => {
    try {
      const res = await ProfileService.editProfile(data);
      const state: any = getState();
      dispatch(getAuthUserProfile());
      dispatch(
        setAuthUser({
          ...state.auth.authUser,
          firstName: res.data.first_name,
          lastName: res.data.last_name,
          avatar: res.data.avatar,
        })
      );
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(17001),
        })
      );
      return res;
    } catch (err) {
      dispatch(
        triggerAlert({
          type: "error",
          children: translateFrontEndAlerts(17002),
        })
      );
      rejectWithValue(err);
    }
  }
);
